<template>
	<div>
		<div v-if="content.purchase_status == 2">
			<div class="button-body">
				<van-button type="danger" @click="cancel()">取消</van-button>
				<van-button type="info" @click="pay()">付款</van-button>
			</div>
		</div>
		<div class="button-onebody" v-if="content.drawing_name">
			<!-- <div class="button-body"> -->
				<van-button type="info" @click="approval()">审核通过</van-button>
			<!-- </div> -->
		</div>
		<div class="button-body" v-else>
			<van-button type="danger" @click="approval(2)" :disabled="isDisabled">拒绝申请</van-button>
			<van-button type="info" @click="approval(1)"  :disabled="isDisabled">通过申请</van-button>
		</div>

		<van-dialog v-model="show" title="填写不通过说明" show-cancel-button confirm-button-text="提交" @confirm="confirm">
			<div style="padding: 15px;">
				<van-field v-model="message" rows="3" autosize label="说明" type="textarea" placeholder="请输入说明" />
			</div>
		</van-dialog>
	</div>
</template>

<script>
import { Toast } from "vant";

export default {
	name: "auditBtn",
	data() {
		return {
			form: {},
			show: false,
			message: "",
			messShow: true,
			isDisabled: false,
		};
	},
	props: {
		mess: {
			type: Boolean,
			default: function() {
				return true;
			},
		},
		content: {
			type: Object,
			default: function() {
				return {};
			},
		},
	},
	methods: {
		approval(type) {
			this.isDisabled=true;
			if (type == 2) {
				if (this.messShow == false) {
					return this.$emit("audit", "2");
				}
				this.show = true;
			} else {
				this.$emit("audit", "");
			}
		},
		confirm() {
			if (!this.message) {
				Toast.fail("请填写说明");
			} else {
				this.$emit("audit", this.message);
			}
		},
		pay() {
			console.log(this.content, "555");
			this.$router.push({ name: "purchasePay", query: this.content });
		},
		cancel() {
			this.$router.go(-1);
		},
	},
	watch: {
		mess: {
			immediate: true,
			handler(newV) {
				this.messShow = newV;
				console.log(this.mess);
			},
		},
	},
};
</script>

<style>
.button-body {
	padding: 0 15%;
	margin-top: 20px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.button-onebody {
	padding: 0 15%;
	margin-top: 20px;
	display: flex;
	align-items: center;
	justify-content: center; /* 水平居中 */
}
</style>
